export default __webpack_public_path__ + "static/media/revision.5ea9f238.svg";